<div id="bingMapTracking" class="bingMap"></div>